export const ordersData = [
  {
    id: 1,
    name: "Paracetamol",
    vendorName: "PharmaCorp",
    bookingDate: "2024-11-05",
    status: "Packaging",
    invoice: "https://via.placeholder.com/300?text=Invoice+1",
    locations: [
      { location: "Warehouse A", date: "2024-11-05" },
      { location: "Warehouse B", date: "2024-11-06" }
    ]
  },
  {
    id: 2,
    name: "Aspirin",
    vendorName: "MediHealth",
    bookingDate: "2024-11-09",
    status: "Out for Delivery",
    invoice: "https://via.placeholder.com/300?text=Invoice",
    locations: [
      { location: "Warehouse X", date: "2024-11-09" },
      { location: "Distribution Center", date: "2024-11-10" }
    ]
  },
  {
    id: 3,
    name: "Ibuprofen",
    vendorName: "MedPlus",
    bookingDate: "2024-11-05",
    status: "Packaging",
    invoice: "https://via.placeholder.com/300?text=Invoice+3",
    locations: [
      { location: "Warehouse Z", date: "2024-11-05" }
    ]
  },
  {
    id: 4,
    name: "Amoxicillin",
    vendorName: "CurePharma",
    bookingDate: "2024-11-07",
    status: "Delivered",
    invoice: "https://via.placeholder.com/300?text=Invoice+4",
    locations: [
      { location: "Warehouse Y", date: "2024-11-07" },
      { location: "Customer Location", date: "2024-11-08" }
    ]
  },
  {
    id: 5,
    name: "Cough Syrup",
    vendorName: "HealthMeds",
    bookingDate: "2024-11-01",
    status: "Out for Delivery",
    invoice: "https://via.placeholder.com/300?text=Invoice+5",
    locations: [
      { location: "Warehouse C", date: "2024-11-01" },
      { location: "Customer Location", date: "2024-11-02" }
    ]
  },
  {
    id: 6,
    name: "Vitamin D",
    vendorName: "NutraHealth",
    bookingDate: "2024-11-02",
    status: "Delivered",
    invoice: "https://via.placeholder.com/300?text=Invoice+6",
    locations: [
      { location: "Warehouse D", date: "2024-11-02" },
      { location: "Customer Location", date: "2024-11-03" }
    ]
  },
  {
    id: 7,
    name: "Diclofenac",
    vendorName: "MediStore",
    bookingDate: "2024-10-25",
    status: "Delivered",
    invoice: "https://via.placeholder.com/300?text=Invoice+7",
    locations: [
      { location: "Warehouse E", date: "2024-10-25" },
      { location: "Customer Location", date: "2024-10-26" }
    ]
  },
  {
    id: 8,
    name: "Hydrochlorothiazide",
    vendorName: "MedSupply",
    bookingDate: "2024-10-15",
    status: "Delivered",
    invoice: "https://via.placeholder.com/300?text=Invoice+10",
    locations: [
      { location: "Warehouse F", date: "2024-10-15" },
      { location: "Customer Location", date: "2024-10-16" }
    ]
  }
];
